import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { Spin, Tooltip } from '@arco-design/web-react';
import { IconDesktop } from '@arco-design/web-react/icon';

const LargeScreenDisplay = lazy(() => import('../data-center/monitor-center/LargeScreen').then((m) => ({ default: m.LargeScreenDisplay })));

export function ShareLargeScreen() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<Spin loading />}>
      <LargeScreenDisplay
        hiddenHeaderButtons
        containerStyle={{ margin: 0, height: '100vh' }}
        fullScreenButtonStyle={{
          position: 'fixed',
          top: '1rem',
          right: '1rem',
        }}
        screenStyle={{
          height: '100vh',
        }}
        fullscreenTrigger={
          <div style={{ cursor: 'pointer', marginRight: '-2rem', marginLeft: '1rem', opacity: '0.7' }}>
            <Tooltip content={t('monitor:toggle-full-screen')} position="right">
              <IconDesktop />
            </Tooltip>
          </div>
        }
      />
    </Suspense>
  );
}
